import imgBusiness from './images/react-business-min.png'
import imgCompany from './images/reactcompany-min.png'
import imgAmazon from './images/amazon-simple-min.png'
import imgEcommerce from './images/ecommerce-shop-min.png'
import imgAirbnb from './images/airbnb-clone-min.png'
import imgTravelGuru from './images/travel-guru-min.png'
import imgCovidTracker from './images/covid19-tracker-min.png'
import imgOnlineClass from './images/online-class-min.png'
import imgBlogApi from './images/blog-api-min.png'
import imgCoreConcept from './images/core-concept-min.png'
import imgToDoList from './images/todo-list-min.png'
import imgSongLyrics from './images/lyrice-app-min.png'
import imgWeatherApi from './images/weather-app-min.png'
import imgNatour from './images/natour-site-min.png'
import imgHomeBooking from './images/home-booking-min.png'
import imgTravelBooking from './images/travel-booking-min.png'
import imgElearning from './images/e-learning-min.png'
import imgLoopLab from './images/loop-lab-min.png'
import imgMultiPage from './images/multi-page-min.png'
import imgMagazine from './images/bootstrap-magazin-min.png'
import imgBlogAdmin from './images/blog-admin-min.png'
import imgCreative from './images/creative-agency-min.png'
import imgVolunteer from './images/volunteer-min.png'

const projectData = [
    {
        "id": 22,
        "img": imgCreative,
        "title": "Creative Agency FullStack",
        "description": "A full-stack IT-Service provider web app where anyone can order their needed service from the service list and have options register and enroll with proper client feedback.",
        "github": "https://github.com/asikurr/creative-agency-front-end",
        "website": "https://creative-agen.web.app/",
    },
    {
        "id": 23,
        "img": imgVolunteer,
        "title": "Volunteer Network FullStack",
        "description": "A full-stack Social service provider web app where anyone can choose their favorite service from the volunteer list and have options register and give the service and if think no service provides.",
        "github": "https://github.com/asikurr/volunteer-front-end",
        "website": "https://volunteer-challenge.web.app/",
    },

    {
        "id": 1,
        "img": imgBusiness,
        "title": "React Business Website",
        "description": "React responsive Business website, Using Reactjs, React-Router, React-bootstrap, Font-Awesome icon , and Netlify Hosting",
        "github": "https://github.com/asikurr/react-business-website",
        "website": "https://hello-business-react.netlify.app/",
    },
    {
        "id": 2,
        "img": imgCompany,
        "title": "React Company Website ",
        "description": "React responsive Company Website Using Reactjs, React-Router, React-bootstrap, Font-Awesome icon , and Firebase Hosting",
        "github": "https://github.com/asikurr/Reactjs-with-lumen-api",
        "website": "https://react-company-site.web.app/",
    },
    {
        "id": 3,
        "img": imgAmazon,
        "title": "Amazon Simple",
        "description": "This is simple Amazon website using React,Firebase-auth, GoogleSignin,  React-bootstrap, React-router, localStorage, font-awesome., and Firebase Hosting",
        "github": "https://github.com/asikurr/amazon-clone",
        "website": "https://site-clone-50c97.web.app/",
    },
    {
        "id": 4,
        "img": imgEcommerce,
        "title": "E-commerce shop",
        "description": "React E-commerce shop, Using Reactjs, Redux, Firebase-Auth, React-Router, React-bootstrap, and Heroku Hosting",
        "github": "https://github.com/asikurr/reactjs-e-commerce",
        "website": "https://eshop-reactjs.herokuapp.com/",
    },
    {
        "id": 5,
        "img": imgAirbnb,
        "title": "Airbnb Simple",
        "description": "React simple Airbnb website, Using Reactjs,React-hooks, React-Router, Material-ui , and Firebase Hosting",
        "github": "https://github.com/asikurr/airbnb-clone",
        "website": "https://airbnb-clone-a88f8.web.app/",
    },
    {
        "id": 6,
        "img": imgTravelGuru,
        "title": "Travel Guru",
        "description": "React simple Travel Booking website, Using Reactjs,Firebase-auth, GoogleSignin, Facebook Signin, User SignIn and SignUp,React-hooks, React-Router, React-bootstrap , and Firebase Hosting",
        "github": "https://github.com/asikurr/travel-guru",
        "website": "https://travel-guru-92053.web.app/",
    },

    {
        "id": 7,
        "img": imgCovidTracker,
        "title": "Covid-19 Tracker",
        "description": "React Covid-19 Tracker App, Using Reactjs, API,React-chartjs-2, React-hooks, Material-ui and Firebase Hosting",
        "github": "https://github.com/asikurr/covid-19-tracker",
        "website": "https://covid-19-tracker-ba859.web.app/",
    },


    {
        "id": 8,
        "img": imgOnlineClass,
        "title": "React Online Class",
        "description": "React responsive Online Class Website Using Reactjs,  CSS Grid , Font-Awesome icon , and Netlify Hosting",
        "github": "https://github.com/asikurr/react-online-class",
        "website": "https://online-class-react.netlify.app/",
    },
    {
        "id": 9,
        "img": imgBlogApi,
        "title": "React Blog Api",
        "description": "React responsive blog Website Using Reactjs,  Material-ui , and Firebase Hosting",
        "github": "https://github.com/asikurr/Blog-API-Assignment",
        "website": "https://blog-api-assignment.web.app/",
    },
    {
        "id": 10,
        "img": imgCoreConcept,
        "title": "React Core Concept",
        "description": "Using React Concept this Website - Like Reactjs, API, React-Router, React-hooks, React-Reducer, Context-Api, Material-ui , and Firebase Hosting",
        "github": "https://github.com/asikurr/React-Core-Concept",
        "website": "https://react-core-c.netlify.app/",
    },
    {
        "id": 11,
        "img": imgToDoList,
        "title": "JavaScript ToDo App",
        "description": "A complete todo list using JavaScript and LocalStorage and Github hosting.",
        "github": "https://github.com/asikurr/JavaScript-ToDo-list",
        "website": "https://asikurr.github.io/JavaScript-ToDo-list/",
    },
    {
        "id": 12,
        "img": imgSongLyrics,
        "title": "Song Lyrics Finder App",
        "description": "A Song Lyrics Finder App site using JavaScript and Lyrice Api and GitHub hosting",
        "github": "https://github.com/asikurr/hard-rock-lyrics-api",
        "website": "https://asikurr.github.io/hard-rock-lyrics-api/",
    },
    {
        "id": 13,
        "img": imgWeatherApi,
        "title": "Weather App",
        "description": "A Weather App site using JavaScript and Weather Api and GitHub hosting",
        "github": "https://github.com/asikurr/weather-apps",
        "website": "https://asikurr.github.io/weather-apps/index.html",
    },
    {
        "id": 14,
        "img": imgNatour,
        "title": "Natour Website",
        "description": "Natour Website Using Html5, Css3, SASS, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/tour-website",
        "website": "https://asikurr.github.io/tour-website/index.html",
    },
    {
        "id": 15,
        "img": imgHomeBooking,
        "title": "Home booking Website",
        "description": "Home booking Website Using Html5, Css3, SASS,Css Grid layout, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/home-booking-app",
        "website": "https://asikurr.github.io/home-booking-app/",
    },
    {
        "id": 16,
        "img": imgTravelBooking,
        "title": "Travel booking Website",
        "description": "Travel booking Website Using Html5, Css3, SASS,Css FlexBox layout, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/travel-booking-app",
        "website": "https://asikurr.github.io/travel-booking-app/",
    },
    {
        "id": 17,
        "img": imgElearning,
        "title": "E-Learning Website",
        "description": "E-Learning Website Using Html5, Css3, Bootstrap, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/travel-booking-app",
        "website": "https://asikurr.github.io/travel-booking-app/",
    },
    {
        "id": 18,
        "img": imgLoopLab,
        "title": "LoopLAB Bootstrap landing page",
        "description": "LoopLAB Bootstrap landing page Website Using Html5, Css3, Bootstrap4, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/LoopLAB-Bootstrap-landing-page",
        "website": "https://asikurr.github.io/LoopLAB-Bootstrap-landing-page",
    },
    {
        "id": 19,
        "img": imgMultiPage,
        "title": "Multi Page Bootstrap4 Site",
        "description": "Multi Page Bootstrap4 Website Using Html5, Css3, Bootstrap4, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/multi-page-bootstrap4-site",
        "website": "https://asikurr.github.io/multi-page-bootstrap4-site/index.html",
    },
    {
        "id": 20,
        "img": imgMagazine,
        "title": "Bootstrap4 Magazine site",
        "description": "Bootstrap4 Magazine Website Using Html5, Css3, Bootstrap4, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/Magazine-Bootstrap4",
        "website": "https://asikurr.github.io/Magazine-Bootstrap4/",
    },
    {
        "id": 21,
        "img": imgBlogAdmin,
        "title": "Blog Admin Panel",
        "description": "Bootstrap4 Blog Admin Panel Using Html5, Css3, Bootstrap4, Full Responsive Site GitHub hosting",
        "github": "https://github.com/asikurr/blog-admin-panel",
        "website": "https://asikurr.github.io/blog-admin-panel/index.html",
    },
]

export default projectData;